import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faGem, faRocket, faBuilding, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function Packages() {
    const navigate = useNavigate();
    const [trialLoading, setTrialLoading] = React.useState(false);
    const [trialError, setTrialError] = React.useState(null);

    // Use the same API as LicenseGuard
    const API = "https://api18081113.sayq.pl";

    const handleStartTrial = async () => {
        setTrialLoading(true);
        setTrialError(null);

        try {
            // Retrieve secretId using the same logic as LicenseGuard (plus userData fallback)
            const userData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
            const secretId = localStorage.getItem("secretId") ||
                localStorage.getItem("secredId") ||
                localStorage.getItem("secret-id") ||
                localStorage.getItem("secred-id") ||
                userData?.secretId;

            if (!secretId) {
                setTrialError("Nie znaleziono identyfikatora eventu. Upewnij się, że jesteś zalogowany.");
                setTrialLoading(false);
                return;
            }

            const response = await fetch(`${API}/start-trial`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ secretId }),
            });

            const data = await response.json();

            if (data.success) {
                // Redirect to admin panel on success
                navigate("/admin-panel");
            } else {
                setTrialError(data.message || "Wystąpił błąd podczas aktywacji.");
            }
        } catch (error) {
            console.error("Trial error:", error);
            setTrialError("Błąd połączenia z serwerem.");
        } finally {
            setTrialLoading(false);
        }
    };

    return (
        <div className="bg-light d-flex flex-column" style={{ height: "100vh", overflowY: "auto" }}>
            {/* Navbar / Header */}
            <div className="bg-white shadow-sm py-3 px-4 d-flex align-items-center justify-content-between">
                <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill px-4 fw-bold">
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Wróć
                </button>
                <h4 className="m-0 fw-bold text-primary">SayQ App Pakiety</h4>
                <div style={{ width: 100 }}></div> {/* spacer */}
            </div>

            <div className="container py-5 flex-grow-1">
                <div className="text-center mb-5 animate-fade-in-down">
                    <h1 className="fw-bold display-4 mb-3">Wybierz plan idealny dla Ciebie</h1>
                    <p className="lead text-secondary">Transparentne ceny, zero ukrytych kosztów.</p>
                </div>

                {/* Pricing Cards */}
                <div className="row g-4 justify-content-center mb-5">

                    {/* BASE */}
                    <div className="col-12 col-md-4">
                        <div className="card h-100 border-0 shadow-sm rounded-4 hover-lift position-relative overflow-hidden">
                            <div className="card-body p-5 d-flex flex-column">
                                <div className="d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle mb-4 mx-auto" style={{ width: 64, height: 64 }}>
                                    <FontAwesomeIcon icon={faRocket} className="fs-3" />
                                </div>
                                <h3 className="text-center fw-bold mb-1">Base</h3>
                                <div className="text-center mb-4">
                                    <span className="display-5 fw-bold text-dark">500 zł</span>
                                    <span className="text-muted small"> /netto</span>
                                </div>

                                <ul className="list-unstyled mb-5 flex-grow-1 px-3">
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Agenda i Prelegenci</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Podstawowe ankiety</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Do 100 uczestników</li>
                                </ul>

                                <button className="btn btn-outline-primary rounded-pill w-100 py-3 fw-bold mt-auto">
                                    Wybierz Pakiet
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ADVANCE */}
                    <div className="col-12 col-md-4">
                        <div className="card h-100 border-0 shadow-lg rounded-4 hover-lift position-relative overflow-hidden transform-scale-1">
                            <div className="position-absolute top-0 start-50 translate-middle-x bg-primary text-white py-1 px-3 rounded-bottom-3 small fw-bold">
                                POLECANY
                            </div>
                            <div className="card-body p-5 d-flex flex-column">
                                <div className="d-flex align-items-center justify-content-center bg-warning-subtle text-warning rounded-circle mb-4 mx-auto" style={{ width: 64, height: 64 }}>
                                    <FontAwesomeIcon icon={faGem} className="fs-3" />
                                </div>
                                <h3 className="text-center fw-bold mb-1">Advance</h3>
                                <div className="text-center mb-4">
                                    <span className="display-5 fw-bold text-dark">2500 zł</span>
                                    <span className="text-muted small"> /netto</span>
                                </div>

                                <ul className="list-unstyled mb-5 flex-grow-1 px-3">
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Wszystko z Base</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Zaawansowane Raporty</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Live Chat & Q&A</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Branding aplikacji</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Do 1000 uczestników</li>
                                </ul>

                                <button className="btn btn-primary rounded-pill w-100 py-3 fw-bold mt-auto shadow-sm">
                                    Wybierz Pakiet
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ENTERPRISE */}
                    <div className="col-12 col-md-4">
                        <div className="card h-100 border-0 shadow-sm rounded-4 hover-lift">
                            <div className="card-body p-5 d-flex flex-column">
                                <div className="d-flex align-items-center justify-content-center bg-dark-subtle text-dark rounded-circle mb-4 mx-auto" style={{ width: 64, height: 64 }}>
                                    <FontAwesomeIcon icon={faBuilding} className="fs-3" />
                                </div>
                                <h3 className="text-center fw-bold mb-1">Enterprise</h3>
                                <div className="text-center mb-4">
                                    <span className="display-6 fw-bold text-dark">Indywidualna</span>
                                    <span className="text-muted small d-block">wycena</span>
                                </div>

                                <ul className="list-unstyled mb-5 flex-grow-1 px-3">
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Nielimitowani uczestnicy</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Dedykowany opiekun</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> Integracje API</li>
                                    <li className="mb-3 d-flex align-items-center"><FontAwesomeIcon icon={faCheck} className="text-success me-3" /> SLA Support</li>
                                </ul>

                                <button className="btn btn-dark rounded-pill w-100 py-3 fw-bold mt-auto">
                                    Skontaktuj się
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Free Trial */}
                <div className="row justify-content-center animate-fade-in-up">
                    <div className="col-12 col-lg-8">
                        <div className="bg-white p-5 rounded-4 shadow-sm text-center border border-light-subtle">
                            <h2 className="fw-bold mb-3">Chcesz sprawdzić jak to działa?</h2>
                            <p className="text-muted mb-4 lead">
                                Przetestuj SayQ App za darmo przez 7 dni. Bez podawania karty.
                            </p>
                            <button
                                onClick={handleStartTrial}
                                disabled={trialLoading}
                                className="btn btn-outline-dark rounded-pill px-5 py-3 fw-bold btn-lg hover-scale"
                            >
                                {trialLoading ? "Aktywacja..." : "Wypróbuj za darmo"}
                            </button>
                            {trialError && <p className="text-danger mt-3 mb-0">{trialError}</p>}
                        </div>
                    </div>
                </div>

            </div>

            <style>{`
          .hover-lift { transition: transform 0.3s ease, box-shadow 0.3s ease; }
          .hover-lift:hover { transform: translateY(-5px); box-shadow: 0 1rem 3rem rgba(0,0,0,.1)!important; }
          .hover-scale:hover { transform: scale(1.05); transition: transform 0.2s; }
          .animate-fade-in-down { animation: fadeInDown 0.8s ease-out; }
          .animate-fade-in-up { animation: fadeInUp 0.8s ease-out; }
          
          @keyframes fadeInDown {
              from { opacity: 0; transform: translateY(-20px); }
              to { opacity: 1; transform: translateY(0); }
          }
           @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
          }
      `}</style>

        </div>
    );
}
